//import ViewCGWordArrPopup from "@/pages/comp/book_order/textbook/popup/view_cg_word_arr";
import ViewCGWordArrPopupArea from "@/pages/comp/book_order/textbook/common/popup/view_cg_word_arr";

function ViewCGWordArrPopup(props: any) {
  let myProps = {
    closePopup: () => { },
    refreshData: (inData: any) => { },
    callbackData: (inData: any) => { },
    cg_word_pri_val_arr: [],
    voice:"",
    ...props
  };

  return (
    <div>
      <ViewCGWordArrPopupArea
        closePopup={myProps.closePopup}
        refreshData={myProps.refreshData}
        callbackData={myProps.callbackData}
        cg_word_pri_val_arr={myProps.cg_word_pri_val_arr}
        voice={myProps.voice}
      ></ViewCGWordArrPopupArea>
    </div>
  );
};
export default ViewCGWordArrPopup;